/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addUserToMerchant } from '../fn/users/add-user-to-merchant';
import { AddUserToMerchant$Params } from '../fn/users/add-user-to-merchant';
import { assignRole } from '../fn/users/assign-role';
import { AssignRole$Params } from '../fn/users/assign-role';
import { assignRoles } from '../fn/users/assign-roles';
import { AssignRoles$Params } from '../fn/users/assign-roles';
import { CollectionModelUserRoleResponseModel } from '../models/collection-model-user-role-response-model';
import { deleteUser } from '../fn/users/delete-user';
import { DeleteUser$Params } from '../fn/users/delete-user';
import { GetMerchantAdminUsersResponse } from '../models/get-merchant-admin-users-response';
import { getRoleById } from '../fn/users/get-role-by-id';
import { GetRoleById$Params } from '../fn/users/get-role-by-id';
import { getRoles } from '../fn/users/get-roles';
import { GetRoles$Params } from '../fn/users/get-roles';
import { getUser } from '../fn/users/get-user';
import { GetUser$Params } from '../fn/users/get-user';
import { listMerchantUsers } from '../fn/users/list-merchant-users';
import { ListMerchantUsers$Params } from '../fn/users/list-merchant-users';
import { listUsers } from '../fn/users/list-users';
import { ListUsers$Params } from '../fn/users/list-users';
import { PagedModelUserResponseModel } from '../models/paged-model-user-response-model';
import { registerMerchantRootUser } from '../fn/users/register-merchant-root-user';
import { RegisterMerchantRootUser$Params } from '../fn/users/register-merchant-root-user';
import { revokeRole } from '../fn/users/revoke-role';
import { RevokeRole$Params } from '../fn/users/revoke-role';
import { revokeRoles } from '../fn/users/revoke-roles';
import { RevokeRoles$Params } from '../fn/users/revoke-roles';
import { setRolesById } from '../fn/users/set-roles-by-id';
import { SetRolesById$Params } from '../fn/users/set-roles-by-id';
import { updateUser } from '../fn/users/update-user';
import { UpdateUser$Params } from '../fn/users/update-user';
import { User } from '../models/user';
import { UserResponseModel } from '../models/user-response-model';
import { UserRoleResponseModel } from '../models/user-role-response-model';


/**
 * User management endpoints. Most operations require EASYLOT_ADMIN or USER_ADMIN role. POST /merchant-root-admin-users is publicly accessible (no auth required).
 */
@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRoles()` */
  static readonly GetRolesPath = '/users/{userId}/roles';

  /**
   * Listing roles.
   *
   * Lists all roles of specified user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles$Response(params: GetRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionModelUserRoleResponseModel>> {
    const obs = getRoles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Listing roles.
   *
   * Lists all roles of specified user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles(params: GetRoles$Params, context?: HttpContext): Observable<CollectionModelUserRoleResponseModel> {
    const resp = this.getRoles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CollectionModelUserRoleResponseModel>): CollectionModelUserRoleResponseModel => r.body)
    );
  }

  /** Path part for operation `setRolesById()` */
  static readonly SetRolesByIdPath = '/users/{userId}/roles';

  /**
   * Setting roles.
   *
   * Sets roles of specified user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setRolesById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setRolesById$Response(params: SetRolesById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = setRolesById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Setting roles.
   *
   * Sets roles of specified user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setRolesById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setRolesById(params: SetRolesById$Params, context?: HttpContext): Observable<void> {
    const resp = this.setRolesById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `revokeRoles()` */
  static readonly RevokeRolesPath = '/users/{userId}/roles';

  /**
   * Revoke roles.
   *
   * Revokes the specified roles from the given user. Requires EASYLOT_ADMIN or USER_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeRoles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revokeRoles$Response(params: RevokeRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = revokeRoles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Revoke roles.
   *
   * Revokes the specified roles from the given user. Requires EASYLOT_ADMIN or USER_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revokeRoles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revokeRoles(params: RevokeRoles$Params, context?: HttpContext): Observable<void> {
    const resp = this.revokeRoles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `assignRoles()` */
  static readonly AssignRolesPath = '/users/{userId}/roles';

  /**
   * Assign roles.
   *
   * Assigns roles of specified user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignRoles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignRoles$Response(params: AssignRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionModelUserRoleResponseModel>> {
    const obs = assignRoles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Assign roles.
   *
   * Assigns roles of specified user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignRoles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignRoles(params: AssignRoles$Params, context?: HttpContext): Observable<CollectionModelUserRoleResponseModel> {
    const resp = this.assignRoles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CollectionModelUserRoleResponseModel>): CollectionModelUserRoleResponseModel => r.body)
    );
  }

  /** Path part for operation `getRoleById()` */
  static readonly GetRoleByIdPath = '/users/{userId}/roles/{roleName}';

  /**
   * Get a single role.
   *
   * Checks whether the specified role is assigned to the given user and returns it. Requires EASYLOT_ADMIN or USER_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoleById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoleById$Response(params: GetRoleById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRoleResponseModel>> {
    const obs = getRoleById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a single role.
   *
   * Checks whether the specified role is assigned to the given user and returns it. Requires EASYLOT_ADMIN or USER_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRoleById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoleById(params: GetRoleById$Params, context?: HttpContext): Observable<UserRoleResponseModel> {
    const resp = this.getRoleById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserRoleResponseModel>): UserRoleResponseModel => r.body)
    );
  }

  /** Path part for operation `assignRole()` */
  static readonly AssignRolePath = '/users/{userId}/roles/{roleName}';

  /**
   * Assign role.
   *
   * Assigns the given role to specified user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  assignRole$Response(params: AssignRole$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRoleResponseModel>> {
    const obs = assignRole(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Assign role.
   *
   * Assigns the given role to specified user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assignRole(params: AssignRole$Params, context?: HttpContext): Observable<UserRoleResponseModel> {
    const resp = this.assignRole$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserRoleResponseModel>): UserRoleResponseModel => r.body)
    );
  }

  /** Path part for operation `revokeRole()` */
  static readonly RevokeRolePath = '/users/{userId}/roles/{roleName}';

  /**
   * Revoke role.
   *
   * Revokes the given role from specified user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeRole$Response(params: RevokeRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = revokeRole(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Revoke role.
   *
   * Revokes the given role from specified user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revokeRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeRole(params: RevokeRole$Params, context?: HttpContext): Observable<void> {
    const resp = this.revokeRole$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateUser()` */
  static readonly UpdateUserPath = '/users/merchant-admin-users/{userId}';

  /**
   * Updating existing merchant user admin.
   *
   * Updates an existing merchant admin user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser$Response(params: UpdateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updating existing merchant user admin.
   *
   * Updates an existing merchant admin user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser(params: UpdateUser$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteUser()` */
  static readonly DeleteUserPath = '/users/merchant-admin-users/{userId}';

  /**
   * Deleting existing merchant user admin.
   *
   * Deletes an existing merchant admin user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser$Response(params: DeleteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deleting existing merchant user admin.
   *
   * Deletes an existing merchant admin user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser(params: DeleteUser$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `registerMerchantRootUser()` */
  static readonly RegisterMerchantRootUserPath = '/users/merchant-root-admin-users';

  /**
   * Registering new merchant root admin.
   *
   * Registers a new merchant root admin and returns the saved resource with its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerMerchantRootUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerMerchantRootUser$Response(params: RegisterMerchantRootUser$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    const obs = registerMerchantRootUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Registering new merchant root admin.
   *
   * Registers a new merchant root admin and returns the saved resource with its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerMerchantRootUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerMerchantRootUser(params: RegisterMerchantRootUser$Params, context?: HttpContext): Observable<User> {
    const resp = this.registerMerchantRootUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<User>): User => r.body)
    );
  }

  /** Path part for operation `listMerchantUsers()` */
  static readonly ListMerchantUsersPath = '/users/merchant-admin-users';

  /**
   * Listing merchant admin users.
   *
   * Lists all the merchant admin users. The merchant is specified by the access token.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listMerchantUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMerchantUsers$Response(params?: ListMerchantUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMerchantAdminUsersResponse>> {
    const obs = listMerchantUsers(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Listing merchant admin users.
   *
   * Lists all the merchant admin users. The merchant is specified by the access token.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listMerchantUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMerchantUsers(params?: ListMerchantUsers$Params, context?: HttpContext): Observable<GetMerchantAdminUsersResponse> {
    const resp = this.listMerchantUsers$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetMerchantAdminUsersResponse>): GetMerchantAdminUsersResponse => r.body)
    );
  }

  /** Path part for operation `addUserToMerchant()` */
  static readonly AddUserToMerchantPath = '/users/merchant-admin-users';

  /**
   * Registering new merchant user admin.
   *
   * Registers a new merchant admin user and returns the saved resource with its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addUserToMerchant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addUserToMerchant$Response(params: AddUserToMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    const obs = addUserToMerchant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Registering new merchant user admin.
   *
   * Registers a new merchant admin user and returns the saved resource with its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addUserToMerchant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addUserToMerchant(params: AddUserToMerchant$Params, context?: HttpContext): Observable<User> {
    const resp = this.addUserToMerchant$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<User>): User => r.body)
    );
  }

  /** Path part for operation `listUsers()` */
  static readonly ListUsersPath = '/users';

  /**
   * Listing users.
   *
   * Lists all users.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUsers$Response(params?: ListUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelUserResponseModel>> {
    const obs = listUsers(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Listing users.
   *
   * Lists all users.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUsers(params?: ListUsers$Params, context?: HttpContext): Observable<PagedModelUserResponseModel> {
    const resp = this.listUsers$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelUserResponseModel>): PagedModelUserResponseModel => r.body)
    );
  }

  /** Path part for operation `getUser()` */
  static readonly GetUserPath = '/users/{userId}';

  /**
   * Get a user.
   *
   * Returns the specified user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser$Response(params: GetUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponseModel>> {
    const obs = getUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a user.
   *
   * Returns the specified user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser(params: GetUser$Params, context?: HttpContext): Observable<UserResponseModel> {
    const resp = this.getUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserResponseModel>): UserResponseModel => r.body)
    );
  }

}
